import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EAlert, IAlertState } from '../../types/alert';
import { SliceActions } from '../types';

const initialState: IAlertState = {
  isVisible: false,
};

type TAlertPayload = {
  type?: EAlert;
  message?: string;
  chatId?: string;
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert(state, action: PayloadAction<TAlertPayload>) {
      state.isVisible = true;
      if (action) {
        state.type = action.payload.type;
        state.message = action.payload.message;
        state.chatId = action.payload.chatId;
      }
    },
    hideAlert() {
      return initialState;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export const alertReducer = alertSlice.reducer;
export type TAlertActions = SliceActions<typeof alertSlice.actions>;
